import { useEffect, useState } from "react";
import { api, brl } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { Plus, Trash2, Edit3 } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", unit: "un", price: 0, description: "" };

export default function ItemsLibrary() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/items").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (editing) await api.put(`/items/${editing}`, { ...form, price: +form.price });
    else await api.post("/items", { ...form, price: +form.price });
    toast.success("Salvo");
    setOpen(false); setEditing(null); setForm(empty); load();
  };
  const startEdit = (it) => { setEditing(it.item_id); setForm(it); setOpen(true); };
  const remove = async (id) => { await api.delete(`/items/${id}`); toast.success("Removido"); load(); };

  return (
    <div className="p-10 max-w-[1200px]">
      <div className="flex items-end justify-between mb-8">
        <div><p className="overline">Cadastro</p><h1 className="font-heading text-4xl mt-2">Biblioteca de Itens & Serviços</h1></div>
        <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) { setEditing(null); setForm(empty); } }}>
          <DialogTrigger asChild><Button className="bg-[#C07C88] hover:bg-[#A86571]" data-testid="new-item-btn"><Plus size={16} className="mr-1" /> Novo item</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{editing ? "Editar" : "Novo"} item</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="item-name" /></div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Unidade</Label><Input value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })} data-testid="item-unit" /></div>
                <div><Label>Preço</Label><Input type="number" step="0.01" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} data-testid="item-price" /></div>
              </div>
              <div><Label>Descrição</Label><Textarea rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="item-desc" /></div>
            </div>
            <DialogFooter><Button className="bg-[#C07C88] hover:bg-[#A86571]" onClick={save} data-testid="save-item-btn">Salvar</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <Card className="border-border shadow-none">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground"><th className="p-4">Nome</th><th className="p-4">Unidade</th><th className="p-4">Preço</th><th className="p-4">Descrição</th><th></th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.item_id} className="border-t border-border" data-testid={`item-${it.item_id}`}>
                <td className="p-4 font-medium">{it.name}</td>
                <td className="p-4 text-muted-foreground">{it.unit}</td>
                <td className="p-4">{brl(it.price)}</td>
                <td className="p-4 text-xs text-muted-foreground">{it.description}</td>
                <td className="p-4 text-right space-x-1">
                  <button onClick={() => startEdit(it)} className="p-1.5 text-muted-foreground hover:text-[#C07C88]" data-testid={`edit-item-${it.item_id}`}><Edit3 size={14} /></button>
                  <button onClick={() => remove(it.item_id)} className="p-1.5 text-muted-foreground hover:text-red-500" data-testid={`del-item-${it.item_id}`}><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="p-10 text-center text-sm text-muted-foreground">Nenhum item cadastrado.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
